export function AddSquare({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.33331 11H14.6666"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11 14.6663V7.33301"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.24998 20.1663H13.75C18.3333 20.1663 20.1666 18.333 20.1666 13.7497V8.24967C20.1666 3.66634 18.3333 1.83301 13.75 1.83301H8.24998C3.66665 1.83301 1.83331 3.66634 1.83331 8.24967V13.7497C1.83331 18.333 3.66665 20.1663 8.24998 20.1663Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
